import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React from "react";
import { useParams } from "react-router-dom";
import { Eye, User, Calendar, ArrowRight, ArrowLeft } from "lucide-react";
import { toYoutubeEmbed } from "../../helper/toYoutubeEmbed";

const ENDPOINT_MAP = {
  feature: "story",
  people: "people",
  video: "video-single",
  webstories: "web-story-single",
  blog: "blog-single",
};

const SingleBusinessPage = ({
  article: articleProp,
  onBack,
  onPrev,
  onNext,
}) => {

  const article = articleProp;

  const isVideo = article?.embed_link || article?.video;
      const iframeUrl = toYoutubeEmbed(isVideo);
  

  const InfoCard = ({ label, value, children }) => {
    if (!value && !children) return null;

    return (
      // <div className="rounded-xl border border-[#9d2e43] px-3 py-2 transition">
      <div className="">
        <p className="text-xs text-gray-500 mb-1">{label}</p>
        <p className="text-sm font-semibold text-gray-900 break-words">
          {children || value}
        </p>
      </div>
    );
  };

  return (
    <div className=" bg-white  shadow-xl rounded-md mt-1">
      <div className="px-4 py-2 flex flex-wrap items-center gap-3 sm:flex-nowrap justify-between">
        {/* LEFT: Back */}
        <button
          onClick={onBack}
          className="order-1 sm:order-none group inline-flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-gray-900"
        >
          <ArrowLeft
            size={16}
            className="transition-transform group-hover:-translate-x-1"
          />
          Back to list
        </button>

        {/* CENTER: Prev / Next */}
        <div className="order-3 w-full sm:order-none sm:w-auto flex justify-center gap-3">
          {/* PREV */}
          <button
            onClick={onPrev}
            className="group flex items-center gap-2 px-4 py-2 rounded-xl
        border border-gray-200 bg-white
        hover:border-orange-400 hover:bg-orange-50
        disabled:opacity-40"
          >
            <ArrowLeft
              size={16}
              className="transition-transform group-hover:-translate-x-1"
            />
            <span className="text-sm font-semibold">Prev</span>
          </button>

          {/* NEXT */}
          <button
            onClick={onNext}
            className="group flex items-center gap-2 px-4 py-2 rounded-xl
        bg-orange-500 text-white
        hover:bg-orange-600
        disabled:opacity-40"
          >
            <span className="text-sm font-semibold">Next</span>
            <ArrowRight
              size={16}
              className="transition-transform group-hover:translate-x-1"
            />
          </button>
        </div>

        {/* RIGHT: Visit */}
        {articleProp?.post_url && (
          <a
            href={articleProp.post_url}
            target="_blank"
            rel="noopener noreferrer"
            className="
        order-2 sm:order-none
        inline-flex items-center gap-1.5
        px-3 py-1.5 rounded-md
        bg-gray-100 text-gray-700
        font-medium text-xs sm:text-sm
        hover:bg-gray-200 transition-colors
      "
          >
            Visit on Site <span>↗</span>
          </a>
        )}
      </div>

      {/* HERO IMAGE */}
<div className="w-full overflow-hidden bg-gray-100">
  {iframeUrl ? (
    <div className="w-full aspect-video">
      <iframe
        src={iframeUrl}
        title={article?.title}
        className="w-full h-full"
        frameBorder="0"
        allowFullScreen
      />
    </div>
  ) : (
    <img
      src={article?.cover_image || article?.image}
      alt={article?.title}
      className="w-full h-auto max-h-[80vh] object-fill"
    />
  )}
</div>

      {/* CONTENT */}
      <div className={` mx-auto   relative z-30 `}>
        <article className=" rounded-2xl ">
          <div className=" px-4 sm:px-6 lg:px-8 py-4 flex flex-wrap items-center justify-between gap-3 pb-3  border-gray-200">
            {/* LEFT: Category */}
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide text-orange-600 bg-orange-50 border border-orange-100">
              {article?.itemcategory_name}
            </span>

            {/* RIGHT: Author · Date · Views */}
            <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
              {/* Author */}
              <span className="inline-flex items-center gap-1.5">
                <User size={14} className="opacity-60" />
                <span className="font-medium text-gray-800">
                  {article?.author || "THT"}
                </span>
              </span>

              {/* <span className="w-1 h-1 rounded-full bg-gray-400" /> */}

              {/* Date */}
              <span className="inline-flex items-center gap-1.5">
                <Calendar size={14} className="opacity-60" />
                <span>
                  {new Date(article?.created_at).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </span>
              </span>

              {/* <span className="w-1 h-1 rounded-full bg-gray-400" /> */}

              {/* Views */}
              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-orange-50 border border-orange-200 text-orange-700 font-semibold">
                <Eye size={15} className="text-orange-600" />
                {article?.view}
                <span className="font-normal text-orange-600">views</span>
              </span>
            </div>
          </div>

          {/* TITLE WITH LEFT IMAGE */}
          <div className="bg-[#faedde] px-4 sm:px-6 lg:px-8 py-3">
            <div className="flex items-center gap-3 sm:gap-4 mb-4 ">
            

              {/* RIGHT TITLE */}
              <h1
                className="
      text-lg
      sm:text-2xl
      lg:text-3xl
      font-bold
      text-gray-900
      leading-snug
    "
              >
                {article?.title || article?.name}
              </h1>
            </div>

            <div
              className=" description "
              dangerouslySetInnerHTML={{ __html: article?.description }}
            />

            <main>
              <section className="bg-gradient-to-br lg:px-10 py-7">
                <div className="mx-auto max-w-7xl  md:p-8">
                  {/* BUSINESS INFO */}
                  <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-orange-500 pl-3">
                    Business Information
                  </h2>
                  <div className="rounded-xl border border-[#9d2e43] px-7 py-5 transition">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 mb-2">
                      <InfoCard label="Business Name" value={article?.name} />
                      <InfoCard
                        label="Category"
                        value={article?.itemcategory_name}
                      />
                      <InfoCard
                        label="Nature of Business"
                        value={article?.nature_of_business}
                      />
                      <InfoCard
                        label="Legal Status"
                        value={article?.legal_status}
                      />
                      <InfoCard
                        label="Working Time"
                        value={article?.business_time}
                      />
                      <InfoCard
                        label="Business Location"
                        value={article?.business_location}
                      />
                    </div>

                    <InfoCard label="Address">
                      {article?.address}, {article?.city}, {article?.state} –{" "}
                      {article?.pincode}
                    </InfoCard>
                  </div>

                  {/* CONTACT */}
                  <h2 className="text-xl font-bold text-gray-900 mt-5 mb-3 border-l-4 border-orange-500 pl-3">
                    Contact & Identity
                  </h2>
                  <div className="rounded-xl border border-[#9d2e43] px-7 py-5 transition">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 mb-2">
                      <InfoCard
                        label="Contact Person"
                        value={article?.contact_person}
                      />
                      <InfoCard
                        label="Designation"
                        value={article?.designation}
                      />
                      <InfoCard label="Mobile" value={article?.mobile} />
                      <InfoCard label="WhatsApp" value={article?.whatsapp} />
                      <InfoCard label="Email" value={article?.email} />
                      <InfoCard
                        label="GST Number"
                        value={article?.gst_number}
                      />
                      <InfoCard
                        label="PAN Number"
                        value={article?.pan_number}
                      />
                    </div>

                    <InfoCard label="Website">
                      <a
                        href={article?.website_url}
                        target="_blank"
                        className="text-orange-600 font-semibold hover:underline" rel="noreferrer"
                      >
                        {article?.website_url}
                      </a>
                    </InfoCard>
                  </div>

                  {/* SOCIAL MEDIA */}
                  <h2 className="text-xl font-bold text-gray-900 mt-5 mb-3 border-l-4 border-orange-500 pl-3">
                    Social Media
                  </h2>

                  <div className="flex flex-wrap gap-3">
                    {article?.facebook_url && (
                      <a
                        href={article.facebook_url}
                        target="_blank"
                        rel="noreferrer"
                        className="
        inline-flex items-center justify-center
        px-4 py-1.5
        rounded-xl
        border border-[#9d2e43]
        text-sm font-medium text-[#9d2e43]
        transition-all duration-200 ease-in-out
        hover:bg-[#9d2e43]/5
        hover:shadow-sm
        hover:-translate-y-[1px]
        active:translate-y-0
      "
                      >
                        Facebook
                      </a>
                    )}

                    {article?.instagram_url && (
                      <a
                        href={article.instagram_url}
                          target="_blank"
                        rel="noreferrer"
                        className="
        inline-flex items-center justify-center
        px-4 py-1.5
        rounded-xl
        border border-[#9d2e43]
        text-sm font-medium text-[#9d2e43]
        transition-all duration-200 ease-in-out
        hover:bg-[#9d2e43]/5
        hover:shadow-sm
        hover:-translate-y-[1px]
        active:translate-y-0
      "
                      >
                        Instagram
                      </a>
                    )}

                    {article?.linkedin_url && (
                      <a
                        href={article.linkedin_url}
                          target="_blank"
                        rel="noreferrer"
                        className="
        inline-flex items-center justify-center
        px-4 py-1.5
        rounded-xl
        border border-[#9d2e43]
        text-sm font-medium text-[#9d2e43]
        transition-all duration-200 ease-in-out
        hover:bg-[#9d2e43]/5
        hover:shadow-sm
        hover:-translate-y-[1px]
        active:translate-y-0
      "
                      >
                        LinkedIn
                      </a>
                    )}

                    {article?.twitter_url && (
                      <a
                        href={article.twitter_url}
                          target="_blank"
                        rel="noreferrer"
                        className="
        inline-flex items-center justify-center
        px-4 py-1.5
        rounded-xl
        border border-[#9d2e43]
        text-sm font-medium text-[#9d2e43]
        transition-all duration-200 ease-in-out
        hover:bg-[#9d2e43]/5
        hover:shadow-sm
        hover:-translate-y-[1px]
        active:translate-y-0
      "
                      >
                        Twitter
                      </a>
                    )}

                    {article?.youtube_url && (
                      <a
                        href={article.youtube_url}
                          target="_blank"
                        rel="noreferrer"
                        className="
        inline-flex items-center justify-center
        px-4 py-1.5
        rounded-xl
        border border-[#9d2e43]
        text-sm font-medium text-[#9d2e43]
        transition-all duration-200 ease-in-out
        hover:bg-[#9d2e43]/5
        hover:shadow-sm
        hover:-translate-y-[1px]
        active:translate-y-0
      "
                      >
                        YouTube
                      </a>
                    )}
                  </div>
                </div>
              </section>
            </main>
          </div>

          <div className="px-4 sm:px-6 lg:px-8  py-2 flex bg-white flex-wrap items-center gap-3 sm:flex-nowrap justify-between">
            {/* LEFT: Back */}
            <button
              onClick={onBack}
              className="order-1 sm:order-none group inline-flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-gray-900"
            >
              <ArrowLeft
                size={16}
                className="transition-transform group-hover:-translate-x-1"
              />
              Back to list
            </button>

            {/* CENTER: Prev / Next */}
            <div className="order-3 w-full sm:order-none sm:w-auto flex justify-center gap-3">
              {/* PREV */}
              <button
                onClick={onPrev}
                className="group flex items-center gap-2 px-4 py-2 rounded-xl
        border border-gray-200 bg-white
        hover:border-orange-400 hover:bg-orange-50
        disabled:opacity-40"
              >
                <ArrowLeft
                  size={16}
                  className="transition-transform group-hover:-translate-x-1"
                />
                <span className="text-sm font-semibold">Prev</span>
              </button>

              {/* NEXT */}
              <button
                onClick={onNext}
                className="group flex items-center gap-2 px-4 py-2 rounded-xl
        bg-orange-500 text-white
        hover:bg-orange-600
        disabled:opacity-40"
              >
                <span className="text-sm font-semibold">Next</span>
                <ArrowRight
                  size={16}
                  className="transition-transform group-hover:translate-x-1"
                />
              </button>
            </div>

            {/* RIGHT: Visit */}
            {articleProp?.post_url && (
              <a
                href={articleProp.post_url}
                target="_blank"
                rel="noopener noreferrer"
                className="
        order-2 sm:order-none
        inline-flex items-center gap-1.5
        px-3 py-1.5 rounded-md
        bg-gray-100 text-gray-700
        font-medium text-xs sm:text-sm
        hover:bg-gray-200 transition-colors
      "
              >
                Visit on Site <span>↗</span>
              </a>
            )}
          </div>
        </article>
      </div>
    </div>
  );
};

export default SingleBusinessPage;
